import React, { useEffect, useState } from 'react';


import ControllerTitle from '../ProductsLanding/06_controllers_title';
import ControllerFlex from '../ProductsLanding/07_controllers_flex';

import bannerImg from '../../Assets/bannersAssets/products_landing.webp';
import Banner from "./Banner"

import '../ProductsLanding/styles/01_banner.css';
import Simulator from '../Simulator/Simulator';
import Verycon2 from './Verycon2';
import VeryconPro from './VeryconPro';
import ContactForms from './ContactForms';
import VeryconDc from './VeryconDc';
import VeryconCompact from './VeryconCompact';
import RelatedProducts from './RelatedProductsWithTitle'

// ...your imports...

export default function Controlers() {
  const [activeIdx, setActiveIdx] = useState(0);
  const tabs = ['Verycon Compact','Verycon 2.0', 'Verycon Pro', 'Verycon DC'];
  const tabIds = [ 'veryconcompact','verycon2', 'veryconpro', 'verycondc'];

  useEffect(() => {
  const hash = window.location.hash;
  
  if (hash) {
    // Remove # from hash
    const id = hash.replace('#', '');
    
    // Wait for DOM to be ready
    setTimeout(() => {
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        
        // Find and set active tab if it's one of our controller sections
        const idx = tabIds.indexOf(id);
        if (idx !== -1) {
          setActiveIdx(idx);
        }
      }
    }, 100);
  }
}, []);

  useEffect(() => {
    document.body.scrollTop = document.documentElement.scrollTop = 0;
  }, []);
  useEffect(() => {
    const handleScroll = () => {
      const offsets = tabIds.map((id) => {
        const el = document.getElementById(id);
        if (el) {
          const rect = el.getBoundingClientRect();
          return { id, top: rect.top };
        }
        return null;
      });
  
      // Find the section nearest to the top (but not too far down)
      const visibleSection = offsets.find(
        (offset) => offset && offset.top >= 0 && offset.top < window.innerHeight / 2
      );
  
      if (visibleSection) {
        const idx = tabIds.indexOf(visibleSection.id);
        if (idx !== -1 && idx !== activeIdx) {
          setActiveIdx(idx);
        }
      }
    };
  
    window.addEventListener('scroll', handleScroll, { passive: true });
  
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [activeIdx, tabIds]);
  

  const scrollToSection = (id, index) => {
    const section = document.getElementById(id);
    if (section) {
      section.scrollIntoView({ behavior: 'smooth', block: 'start' });
      setActiveIdx(index);
    }
  };

  return (
    <>
      <Banner />

      {/* Stylish Tab Bar */}
      <div className="md:w-6/12 lg:w-6/12 xxl:px-10 container max-w-6/12 mx-auto lg:block hidden sticky top-3 z-20 pb-6" id="controllers">
        <div className="rounded-full w-full mb-1 xl:mb-2 bg-gray-200 bg-tab-shadow flex-wrap gap-3 items-center justify-around overflow-visible px-5 py-3 flex">
          {tabs.map((tab, index) => (
            <button
              key={index}
              onClick={() => scrollToSection(tabIds[index], index)}
              className={`${
                activeIdx === index ? 'bg-white text-black shadow' : 'text-gray-600'
              } hover:text-green font-poppins text-base xl:text-lg rounded-full px-4 py-2 transition-colors duration-300`}
            >
              {tab}
            </button>
          ))}
        </div>
      </div>

      {/* Verycon Sections */}
      <div id="veryconcompact">
        <VeryconCompact/>
      </div>
      <div id="verycon2">
        <Verycon2 />
      </div>
      <div id="veryconpro">
        <VeryconPro />
      </div>
      <div id="verycondc">
        <VeryconDc />
      </div>
      
  
      <RelatedProducts />
      <ContactForms className="true"/>    
      {/* <Simulator /> */}
    </>
  );
}
